<template>
 <div v-if="hasLoad">
    <!-- PC端头部 -->
    <examinationHeader v-if="visitSource == 2 || homeBarType == 1" ref="header" :initHomeBarArr="homeBarArr" :initActiveName="activeName" @menuHandleClick="menuHandleClick" @tabHandleClick="tabHandleClick" ></examinationHeader>
    <!-- 页面内容部分 -->
    <el-row :style="visitSource == 3?'padding-bottom: 50px':''" type="flex" justify="center">
      <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
        <!-- <template v-for="(item,index) in homeBarArr"> -->
          <!-- <template  v-if="activeName == item.barKey && item.ifLoaded" > -->
          <template  v-if="activeHomeBarOne.ifLoaded" >
            <kw_list :key="'homeTab_'+activeHomeBarOne.barKey + '_' + (activeHomeBarOne.mainId?activeHomeBarOne.mainId:'0')" v-if="activeHomeBarOne.pageType == 1" :ref="activeHomeBarOne.barKey==1?'kw_list':'kw_list_'+activeHomeBarOne.barKey" :initPageObj="activeHomeBarOne"></kw_list>
            <kw_look :key="'homeTab_'+activeHomeBarOne.barKey + '_' + (activeHomeBarOne.mainId?activeHomeBarOne.mainId:'0')" v-else-if="activeHomeBarOne.mainId>=0" :ref="activeHomeBarOne.barKey==1?'kw_look':'kw_look_'+activeHomeBarOne.barKey" :pageInfo="activeHomeBarOne"></kw_look>
          </template>
          <!-- </template> -->
        <!-- </template> -->
      </el-col>
    </el-row>
    <!-- 手机端 底部放置选项卡 -->
    <div class="button_menu" v-if="visitSource == 3 && homeBarType == 0">
      <template v-for="(item,index) in homeBarArr">
        <div :key="'homeTab_'+index" class="item_menu" :style="'width:'+(100/homeBarShowLength)+'%'"  @click="menuHandleClick(index+'')" v-if="item.ifShow==1">
        <i :class="(activeName == index)?'active_menu'+' '+item.barCurrentIcon:''+item.barCurrentIcon" style="font-size: 20px"></i>
        <div class="title_menu" :class="activeName == index?'active_menu':''">{{item.barName}}</div>
        </div>
      </template>
    </div>
    <!-- PC端底部 -->
    <examinationFooter v-else></examinationFooter>
 </div>
 <div v-else>
     <div v-if="visitSource == 2" style="display: flex;justify-content: center;padding: 10px 0">
         <i class="el-icon-loading"></i>
     </div>
     <div v-else>页面加载中!</div>
 </div>
</template>

<script>
 import pageUtils from '@/js/page/pageUtil.js';
 import utils from '@/js/utils/util.js';
 // 53客服组件
//  import kf from '@/components/kw/kf.vue';
  //PC考试底部内容
  import examinationFooter from '@/components/footer/examinationFooter.vue';
  //PC考试头部内容
  import examinationHeader from '@/components/header/examinationHeader.vue';
 export default {
  name: 'MailHome',
  props: {
  },
  data() {
   return {
    // 访问来源 PC:2 或者 H5:3
    visitSource:utils.checkVisitSource(),
    // 登录人的信息
    loginInfo:null,
    //项目表中的信息
    programaSetInfo:null,
    activeName:"0",
    // 是否进行数据渲染
    hasLoad:false,
    activeHomeBarOne:{},
    homeBarType:0,
    // 商城首页的 菜单信息
    homeBarArr:[{
     barName:"可为平台",
     barIcon:"homepage",
     barCurrentIcon:"el-icon-s-home",
     barKey:"1",
     mainIdType:"shamOpenId",
     ifShow:1,
     // 是否需要登录
     ifLogin:2,
     pageId: 60,
     tableId: 35,
     pageType: 11,
     listTableId: 463,
     mainId: 0,
     ifLoaded: true
    }],
    homeBarShowLength:4
   };
  },
  created() {
    var that = this;
    var shamOpenId = pageUtils.getShamOpenId();
    var paramOptions = this.$route.params;
    if(paramOptions) {
      if(paramOptions.tabName) {
        if(!paramOptions.domain_name) {
          localStorage.domain_name = "";
        }
      }
    }
    //判断是否有后台的localStorage.homeMenuList
    var homeMenuList = pageUtils.getHomeMenuList();
    console.log("homeMenuList===================================",homeMenuList);
    // if(utils.isNotNull(homeMenuList)) {
      that.homeBarArr = JSON.parse(homeMenuList);
      that.homeBarType = pageUtils.getHomeBarType();
    // }
    console.log("shamOpenId================================",shamOpenId);
    if((shamOpenId>0)) {
      that.initShamInfo(that);
    } else {
      if(pageUtils.isWeixinCient()) {
        var options = this.$route.params;
        if(!options.pageId) {
          options = this.$route.query;
        }
        var code = options.code;
        if(code) {
          utils.getWxOpenId(that,code,that.initShamInfo);
        } else {
          //判断是否是微信内打开 如果是微信内打开则跳转到获取code 调用获取openId的方法
          utils.getWxCode(that);
        }
      } else {
          // 获取PC电脑本次登录信息 用于单点登录或者页面设置信息的记录
          utils.getShamLoginId(that,that.initShamInfo);
      }
    }

    // 登录人的信息
    if(utils.isNotNull(localStorage.loginInfo)) {
        that.loginInfo = JSON.parse(localStorage.loginInfo);
    }
    var programaSetInfo = pageUtils.getSessionParam("programaSetInfo");
    if(programaSetInfo) {
      this.programaSetInfo = JSON.parse(programaSetInfo);
    }
  },
  mounted() {
//   if(this.$route.params){
//    if(this.$route.params.tabName){
//     var pathData = this.$route.params
//     this.handleClick(pathData.tabName,pathData.index)
//    }
//   }
    window.zdyRefreshPage = (e) => {
      this.zdyRefreshPage();
    }
  },
  watch:{
  },
  computed:{

  },
  components: {
    // kf\
    examinationFooter,
    examinationHeader,
    kw_look:resolve => require(['@/components/look/kw_look.vue'], resolve),
    kw_list:resolve => require(['@/components/list/kw_list.vue'], resolve),
  },
  methods: {
    /**
     * 虚拟登录账户获取后的操作逻辑
     */
    initShamInfo(that) {
      if(!that) {
        that = this;
      }
      // 登录人的信息
      if(utils.isNotNull(localStorage.loginInfo)) {
        that.loginInfo = JSON.parse(localStorage.loginInfo);
      } else {
        that.loginInfo = null;
      }
      var loginInfo = that.loginInfo;
      var userId = -1;
      var login_proId = "";
      if(loginInfo) {
        userId = loginInfo.USERID;
        login_proId = loginInfo.login_proId;
      }
      var shamOpenId = pageUtils.getShamOpenId();
      console.log("shamOpenId============================",shamOpenId,userId,login_proId,loginInfo);
      // 判断是否已经获取到了openId 
      if (shamOpenId > 0) {
        var homeBarShowLength = 0;
        var homeMenuList = pageUtils.getHomeMenuList();
        // if(!that.homeBarArr || that.homeBarArr.length == 0 && utils.isNotNull(homeMenuList)) {
          that.homeBarArr = JSON.parse(homeMenuList);
          that.homeBarType = pageUtils.getHomeBarType();
        // }
        var homeBarArr = that.homeBarArr;
        console.log("homeBarArr============================",homeBarArr, userId);
        var ifLx = localStorage.ifLx;
        var current = "";
        if(homeBarArr && homeBarArr.length > 0) {
          var ifInit = false;
          homeBarArr.forEach((barOne, barIndex) => {
            that.initShamInfoHomeBarOne(barOne,shamOpenId,userId,login_proId,ifInit);
            if (barOne.proId == null || !login_proId || barOne.proId == login_proId) {
              if(barOne.ifShow == 1) {
                homeBarShowLength++;
              }
              ifInit = true;
            }
            if(barOne.childMenu && barOne.childMenu.length > 0) {
              barOne.childMenu.forEach((childBarOne, childBarIndex) => {
                if (childBarOne.proId == null || !login_proId || childBarOne.proId == login_proId) {
                  that.initShamInfoHomeBarOne(childBarOne,shamOpenId,userId,login_proId,ifInit);
                }
                ifInit = true;
              })
            }
          })
        } else {
          that.activeHomeBarOne = {};
        }
        
        that.homeBarShowLength = homeBarShowLength;
        var paramOptions = that.$route.query;
        if(paramOptions) {
          if(paramOptions.initActiveName) {
            that.menuHandleClick(paramOptions.initActiveName+"");
          }
        }
        // pageUtils.initScene(that, options.scene, null);
       console.log("homeBarArr==================2222================", that.homeBarArr,that.activeHomeBarOne,that.activeName,login_proId);
      } else {
        // utils.wxLoginUtil(app,options);
      }
      that.$forceUpdate();
      pageUtils.flutterWebPageFinished();
      that.hasLoad = true;
    },
    initShamInfoHomeBarOne:function(barOne,shamOpenId,userId,login_proId,ifInit){
      var that = this;
      if (barOne.mainIdType == "shamOpenId") {
        barOne.mainId = shamOpenId;
        barOne.ifLoaded = true;
      } else if (barOne.mainIdType == "userId") {
        if (userId > 0) {
          barOne.mainId = userId;
          barOne.ifLoaded = true;
        } else {
          // 打开登录页面
          if(that.$router.app.$children[0].openLogin) {
            that.$router.app.$children[0].openLogin(null,that.initShamInfo);
          }
          barOne.ifLoaded = true;
        }
      }
      console.log("barOne==================77777777777===========",barOne,that.activeHomeBarOne);
      if (barOne.proId == null || !login_proId || barOne.proId == login_proId) {
        barOne.ifShow = 1;
        // if(!that.activeHomeBarOne.pageId>0) {
        if(!ifInit) {
          that.activeHomeBarOne = barOne;
        }
        // }
      } else {
        barOne.ifShow = 2;
      }
      console.log("barOne==================88888888===========",barOne,that.activeHomeBarOne);
    },
    tabHandleClick:function(tab, event){
      console.log("tab------------------",tab,event);
      var index = tab.index;
      var tabName = this.homeBarArr[index].barKey;
      this.handleClick(tabName,index);
    },
    menuHandleClick:function(index,indexPath){
      var that = this;
      console.log("menuHandleClick------------------",index,indexPath);
      var tmp = that.homeBarArr;
      var indexArr = index.split("_");
      indexArr.forEach(oneIndex => {
        if(tmp.childMenu) {
          tmp = tmp.childMenu[oneIndex];
        } else {
          tmp = tmp[oneIndex];
        }
      });
      that.handleClickPageOne(tmp);
      that.activeName = index+'';
    },
   /**
    * PC端 点击切换时
    * 调用 handleChange 页签的切换
    */
   handleClick: function(tabName,index){
      var that = this;
      
      var homeBarArr = that.homeBarArr;
      var pageOne = homeBarArr[index];
      that.handleClickPageOne(pageOne);
      ///////////////////////////
      // pageOne.ifLoaded = true;
      ///////////////////////////
      console.log("homeBarArr==============================",homeBarArr);
      console.log("tabName==============================",tabName);
      that.homeBarArr = homeBarArr;
      that.activeName = tabName+"";
   },
   handleClickPageOne(pageOne) {
     var that = this;
     // 登录人的信息
      if(utils.isNotNull(localStorage.loginInfo)) {
        that.loginInfo = JSON.parse(localStorage.loginInfo);
      }
     var loginInfo = that.loginInfo;
      var userId = -1;
      if(loginInfo) {
        userId = loginInfo.USERID;
      }
      console.log("loginInfo==============================",loginInfo);
      console.log("userId==============================",userId);
      if (pageOne.ifLogin==1 && !(userId>0)) {
      // 打开弹窗登录页面 登录后继续进行触发
      // 如果未登录 进行打开登录页面的操作
        if(that.$router.app.$children[0].openLogin) {
          that.$router.app.$children[0].openLogin();
        }
        return;
      }
      if (pageOne.ifLogin==1) {
        if (userId > 0) {
          pageOne.mainId = userId;
          pageOne.ifLoaded = true;
        }
      } else {
        pageOne.ifLoaded = true;
      }
      if(pageOne.pageId > 0) {
        that.activeHomeBarOne = pageOne;
      }
      console.log("activeHomeBarOne==============================",that.activeHomeBarOne,that.activeName);
   },
   /**
    * 页签切换时
    */
   handleChange: function(tab, event){
    var that = this;
    console.log(tab, event);
    that.handleClick(tab.name);
   },
   zdyRefreshPage:function(){
     var that = this;
     console.log("zdyRefreshPage=============mailHome===============================");
     this.hasLoad = false;
     this.$nextTick(function(){
       that.hasLoad = true;
     })
   },
   checkLogin(){
      var that = this
      var userId = -1;
      if(utils.isNotNull(localStorage.loginInfo)) {
          that.loginInfo = JSON.parse(localStorage.loginInfo);
      }
      var loginInfo = that.loginInfo;
      if(loginInfo) {
          userId = loginInfo.USERID;
      }
      if (!(userId>0)) {
          // 打开弹窗登录页面 登录后继续进行触发
          // 如果未登录 进行打开登录页面的操作
          if(that.$router.app.$children[0].openLogin) {
              that.$router.app.$children[0].openLogin();
              // that.whetherLogIn = false
          }
          return;
      }
    },
    checkLoginOut(){
      var that = this;
      // 暂时只保留退出登录按钮
      utils.loginOut(that);
    }
  }
 }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .top_menu{background: #fff;border-top: 1px solid #e9eaec;padding: 5px}
 .button_menu{position: fixed;left: 0;right: 0;bottom: 0;background: #fff;height: 50px;border-top: 1px solid #e9eaec;padding-top: 5px}
 .item_menu{text-align: center;display: inline-block;}
 .title_menu{font-size: 12px}
 .active_menu{color: #f759ab}
 .el-footer{padding: 0}
 .el-main{padding: 0}
</style>